module.exports = __webpack_public_path__ + "static/media/2019Arvind.90575de6.jpg";